module.exports = __webpack_public_path__ + "img/8.f0d5dc98.png";